<template>
    <div>

   <!-- 单选 -->
       <Select 
             v-if="isMultiple==2"
             :ref="refName"
             :filterable='filterable'
             remote
             transfer
             :clearable="clearable"
             :loading="loading"
             :remote-method="getRemoteData"
             @on-query-change="getRemoteData"
             @on-clear="clearData"
              :placeholder='placeholderText'
       >
           <Option v-for="(item) in dataList" :disabled="item.disabled" :label="item[labelName]+''" :value="item[valName]" :key="item[valName]" style='display:flex;align-items: center;justify-content: space-between;' @click.native="setVal(item)"><span>{{ item[labelName] }}</span> <span v-if="labelNameNew">{{ item[labelNameNew] }}</span></Option>
       
           <Page v-if="showPage" :total="totalName" size="small" :show-total="false" :page-size="pageSizeName" :current="currentPageName"  @on-change="handlePageName" />
       </Select>
      
    </div>
   </template>
   <!-- 1、新增时，调用getdata接口，初始化数据 -->
   <!-- 2、编辑时，调用setDefVal，，赋默认值 -->
   <!-- 3、弹窗关闭时，调用clearVal，，清空数据 -->
   <script>
       import common from '@/common/common.js';
       import { mapState } from 'vuex'
       export default {
           name: "selectList",
           components: {
           },
           props: {
               url: String,//接口的链接
               selectUrlQuery:{
                   type:Object,
                   default:()=>{}
               },
               valName: String,//传入后台的值
               labelName: String,//对外显示的说明
               refName: String,//对外显示的说明
               isMultiple:{ //是否多选  1  多选 2单选 3 单选 直接数据
                   type: [Number,String],
                   default: 2
               },
               filterable:{//是否支持远程搜索。默认支持
                   type: Boolean,
                   default: true
               },
               keyword: { //搜索词的字段名
                   type: String,
                   default: ''
               },
               labelNameNew: { //备注字段
                   type: String,
                   default: ''
               },
               clearable:{//是否可清空
                   type: Boolean,
                   default: true
               },
               checkedList:{//选中的值 多选时传入数组
                   type: String|Array,
                   default: ''
               },
               placeholderText:{
                   type:[String,Number],
                   default:'请输入'
               },
               index:{//操作对应的索引
                   type: Number,
                   default: 0
               },
               allowCreate:{
                   type: Boolean,
                   default: false
               },
               needName:{//必须有数据，不然提示请先创建数据
                   type:String,
                   default:''
               },
               addAll:{//全部类别，加到第一个
                   type:String,
                   default:''
               },
               listName:{//列表的名称
                   type:String,
                   default:''
               },
               showPage:{//是否展示分页
                   type:Boolean,
                   type:true
               }
           },
           data() {
               return {
                   loading:false,
                   dataList:[],
                   hasChecked:[],
                   setValFlag:false,
                   totalName: 0, // 总数
                   pageSizeName: 5, // 每页数目
                   currentPageName: 1 // 当前
               }
           },
           computed:{
                ...mapState(['local','uInfo','selectId']),
           },
   
           created() {
           },
           mounted() {
               this.$nextTick(() => {
                 
               })
            //    console.log('selectUrlQuery',this.selectUrlQuery)
            //    this.getData()
   
           },
           destroyed() {
           },
           methods: {
               getData(query){//获取列表信息,带分页回显，只有id的情况需要可以按照id精确匹配结果
                  
                   let params = {}

                   if(typeof query != 'object'){

                       if(this.setValFlag){ //赋默认值时传的是id，搜索词按照id来，
                            params[this.valName] = query
                       }else if(this.keyword){
                            params[this.keyword] = query
                       }else{
                           params[this.labelName] = query
                       }
                   }else{
                        if(this.setValFlag && this.keyword){ 
                           params[this.keyword] = query[this.keyword]
                       }else if(this.setValFlag && this.labelName){
                           params[this.labelName] = query[this.labelName]
                       }else{
                        params[this.valName] = query[this.valName]
                       }
                   }
                  
                   let pageParams = {};
                   if(this.showPage){
                       pageParams = {
                           page:this.currentPageName,
                           limit:this.pageSizeName || 5
                       }
                   }else{
                       pageParams = {}
                   }
   
                   let objData = {
                           ...params,
                           dealerId:this.selectId,
                           ...this.selectUrlQuery,
                           ...pageParams
                       
                   }


                   // console.log('this.setValFlag',this.setValFlag)
   
                    // console.log('this.objData',objData)
   
                   // console.log('this.selectUrlQuery',this.selectUrlQuery)
                   this.loading = true;
                   setTimeout(() => {
   
                       this.axios.post(this.url,objData).then((result) => {
                           // console.log(result.data)
                           this.loading = false;
                           //处理数组
                           // console.log('result',result)
                           if(result.data.code == 1){
                               if(this.isMultiple == 3){
                                   this.dataList = result.data.data
                               }else{
                                   // this.dataList = result.data.data.list != undefined?result.data.data.list: (result.data.data.dealersList !=undefined? result.data.data.dealersList: result.data.data)
                                   if(!result.data.data.meta){
                                       this.dataList = result.data.data
                                       this.totalName = this.dataList.length
                                   }else{
                                       this.dataList = result.data.data[this.listName]
                                       this.totalName = result.data.data.meta.count
                                   }
                               }


                               if(this.setValFlag &&  this.dataList.length){//赋默认值，因为保存的只有id，没有label

                                    let setValObj = {}
                                    if(this.dataList.length==1){
                                        setValObj = {
                                            label: this.dataList[0][this.labelName],
                                            tag: undefined,
                                            value:  this.dataList[0][this.valName]
                                        }
                                        
                                    }else{
                                        let key = this.valName 
                                        if(typeof query != 'object'){
                                            key = this.valName 
                                        }else{
                                            if( this.keyword){
                                                key = this.keyword
                                            }else if(this.labelName){
                                                key = this.labelName
                                            }else{
                                                key = this.valName
                                            }
                                        }
                                        this.dataList.length.map(item=>{
                                           if(typeof query != 'object'){
                                                if(item[key]==query){
                                                  setValObj = {
                                                      label: item[this.labelName],
                                                      tag: undefined,
                                                      value:  item[this.valName]
                                                  }
                                               }
                                           }else{
                                               if(item[key]==query[key]){
                                                  setValObj = {
                                                      label: item[this.labelName],
                                                      tag: undefined,
                                                      value:  item[this.valName]
                                                  }
                                               }
                                           }
                                       })

                                    }
                                    this.$refs[this.refName].values = []
                                    this.$refs[this.refName].values.push({
                                       label: setValObj.label,
                                       tag: undefined,
                                       value:  setValObj.value
                                    })

                                    // this.$refs[this.refName].values = []
                                    // this.$refs[this.refName].values.push({
                                    //    label: this.dataList[0][this.labelName],
                                    //    tag: undefined,
                                    //    value:  this.dataList[0][this.valName]
                                    // })

                                 
                               }else if(this.setValFlag &&  this.dataList.length==0){
                                  this.$refs[this.refName].values = []
                               }
   
   
                               if(this.dataList.length==0 && this.needName){//必须有数据，不然提示请先创建数据
                                   let id = this.valName
                                   let val = this.labelName
                                   let finallyData={};
                                   finallyData[id] = ''
                                   finallyData[val] = this.needName
                                   finallyData['disabled'] = true
                                   this.dataList.push(finallyData)
                                   // common.msg('error','请先创建'+this.needName)
                               }
                               if(this.dataList.length>0 && this.addAll){//全部类别，加到第一个
                                 
                                   let id = this.valName
                                   let val = this.labelName
                                   let finallyData={};
                                   finallyData[id] = '0'
                                   finallyData[val] =this.$t(this.addAll)
                                   this.dataList.unshift(finallyData)
   
                               }
                               this.setValFlag = false
                               
   
                               // console.log('this.dataList',this.dataList)
                           }else{
                               common.msg('error',result.data.message,()=>{
                                   this.setValFlag = false
                               })
                           }
                       }).catch((err) => {
                           // console.log(err)
                           this.loading = false;
                           this.setValFlag = false
                           // common.msg('error','获取失败',()=>{})
                       })
   
                   }, 200);
               },
               clearData(){//清空数据，重新请求接口
                this.currentPageName = 1
                this.pageSizeName = 5
                this.getData()
                this.$refs[this.refName].values = []
                this.$emit('setSelected',  null)
               },
               setDefVal(obj){//设置默认值
                   console.log('setDefValsetDefValsetDefValsetDefVal',obj)
                   if(!obj){
                       this.$refs[this.refName].values = []
                       return
                   }
                   this.setValFlag = true
                   this.currentPageName = 1
                   this.pageSizeName = 5;
                   this.getData(obj)   
               },
               clearVal(){//弹窗关闭时，调用clearVal，，清空数据
                this.currentPageName = 1
                this.pageSizeName = 5
                this.$refs[this.refName].values = []
               },
               setVal(data){//选定值，传给父
                     this.$refs[this.refName].values = []
                     this.$refs[this.refName].values.push({
                        label: data[this.labelName],
                        tag: undefined,
                        value: data[this.valName]
                     })
                  this.$emit('setSelected', data || null)
               },
               async handlePageName (val) {//点击分页
                   this.currentPageName = val
                   this.getData()
               },
               getRemoteData:common.antiShake(function(query){//远程搜索
                   this.currentPageName = 1
                   this.pageSizeName = 5;
                   this.getData(query)
               })
           }
       }
   </script>
   <style scoped>
   
     .feedbackText {
       font-size: 10px;
     }
     .ivu-select-dropdown{
       max-width: 300px;
       overflow:auto
     }
   </style>
   